import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { reducers, effects } from '@usimweb/state/store';
import { UiSharedModule } from '@usimweb/ui/shared';

import { ProjectsComponent } from './projects/projects.component';
import { NewProjectComponent } from './new-project/new-project.component';
import { ContactsComponent } from './contacts/contacts.component';
import { InvConfirmationComponent } from './inv-confirmation/inv-confirmation.component';
import { VersionsComponent } from './versions/versions.component';
import { ErrorComponent } from './error/error.component';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ChartComponent } from './credits/chart.component';
import { CreditsComponent } from './credits/credits.component';

import { LetDirective } from '@ngrx/component';

@NgModule({
  declarations: [ProjectsComponent, NewProjectComponent, ContactsComponent, InvConfirmationComponent, VersionsComponent, ChartComponent, CreditsComponent, ErrorComponent],
  imports: [CommonModule, StoreModule.forFeature('appState', reducers), EffectsModule.forFeature(effects), UiSharedModule, LetDirective],
  exports: [ProjectsComponent, NewProjectComponent, ContactsComponent, InvConfirmationComponent, VersionsComponent, CreditsComponent, ErrorComponent],
})
export class UiFeatureModule {}
